import { makeAutoObservable } from 'mobx';
import { BookingApi } from 'shared/api';
import { IGetCalendarCardMonthParams } from 'shared/api/booking/interfaces/get-calendar-card-month.params.interface';
import { IMonthCalendarDay } from 'shared/api/booking/interfaces/calendar-card-month.interface';
import { ICalendarDate } from './calendar-date';

export class MonthCalendarStore {
  private _monthCalendar: Array<IMonthCalendarDay> = [];

  serviceId?: string;
  employeeId?: string;
  currentDate: ICalendarDate;

  // Состояние, которое реально отслеживает MobX

  constructor() {
    const now = new Date();
    const nowDate: ICalendarDate = {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: now.getDate(),
    };

    this.currentDate = nowDate;

    makeAutoObservable(this);
  }

  // Вспомогательный приватный метод для загрузки (не является экшеном)

  // Экшен для изменения даты

  fetchCalendarMonthInfo = (dto: IGetCalendarCardMonthParams) => {
    if (dto.pointId) {
      BookingApi.getCalendarMonthInfo({
        ...dto,
        serviceId: dto.serviceId || this.serviceId || undefined,
        employeeId: dto.employeeId || this.employeeId || undefined,
        month: dto.month + 1,
      }).then((res) => {
        this._monthCalendar = res.result;
        const date = new Date(res.currentDate);
        this.currentDate = {
          year: date.getFullYear(),
          month: date.getMonth(),
          day: date.getDate(),
        };
      });
    }
  };

  get monthCalendar() {
    return this._monthCalendar;
  }
}
export const monthCalendarStore = new MonthCalendarStore();
